var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-white container text-center mx-4 py-4 border-b-2 border-blue rounded"
  }, [_c('div', {
    staticClass: "font-medium text-2xl"
  }, [_vm._v("Monthly pricing calculator")]), _vm._v(" "), _c('div', {
    staticClass: "line my-4"
  }), _vm._v(" "), _c('p', {
    staticClass: "mb-4"
  }, [_vm._v("How many WHOIS requests do you plan on generating each month?")]), _vm._v(" "), _c('div', {
    staticClass: "w-full px-4"
  }, [_c('input', {
    staticClass: "w-full p-4 border border-grey rounded focus:border-blue hover:border-blue",
    attrs: {
      "placeholder": "Enter monthly volume",
      "type": "text"
    },
    domProps: {
      "value": _vm.requests
    },
    on: {
      "input": _vm.onInput
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "w-full text-left my-4",
    attrs: {
      "border": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', {
    staticClass: "border-t border-b border-grey-light"
  }, [_c('tr', {
    staticClass: "tier bg-grey-lighter"
  }, [_c('td', [_vm._v("0  -  1,000")]), _vm._v(" "), _c('td', {
    staticClass: "cost"
  }, [_vm._v("Free")]), _vm._v(" "), _c('td', {
    staticClass: "your-cost"
  }, [_c('span', [_vm._v(_vm._s(_vm.formatCost(_vm.tierOneCost, 2)))])])]), _vm._v(" "), _c('tr', {
    staticClass: "tier"
  }, [_c('td', [_vm._v("Next 50,000")]), _vm._v(" "), _c('td', {
    staticClass: "cost"
  }, [_vm._v("$0.009")]), _vm._v(" "), _c('td', {
    staticClass: "your-cost",
    attrs: {
      "id": "table-calc-tier1"
    }
  }, [_vm._v(_vm._s(_vm.formatCost(_vm.tierTwoCost, 3)))])]), _vm._v(" "), _c('tr', {
    staticClass: "tier bg-grey-lighter"
  }, [_c('td', [_vm._v("Next 200,000")]), _vm._v(" "), _c('td', {
    staticClass: "cost"
  }, [_vm._v("$0.006")]), _vm._v(" "), _c('td', {
    staticClass: "your-cost",
    attrs: {
      "id": "table-calc-tier2"
    }
  }, [_vm._v(_vm._s(_vm.formatCost(_vm.tierThreeCost, 3)))])]), _vm._v(" "), _c('tr', {
    staticClass: "tier"
  }, [_c('td', [_vm._v("Next 500,000")]), _vm._v(" "), _c('td', {
    staticClass: "cost"
  }, [_vm._v("$0.004")]), _vm._v(" "), _c('td', {
    staticClass: "your-cost",
    attrs: {
      "id": "table-calc-tier3"
    }
  }, [_vm._v(_vm._s(_vm.formatCost(_vm.tierFourCost, 3)))])]), _vm._v(" "), _c('tr', {
    staticClass: "tier bg-grey-lighter"
  }, [_c('td', [_vm._v("Any Additional")]), _vm._v(" "), _c('td', {
    staticClass: "cost"
  }, [_vm._v("$0.002")]), _vm._v(" "), _c('td', {
    staticClass: "your-cost",
    attrs: {
      "id": "table-calc-tier4"
    }
  }, [_vm._v(_vm._s(_vm.formatCost(_vm.tierFiveCost, 3)))])])]), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "total-cost-row"
  }, [_c('td', {
    staticClass: "text-2xl"
  }, [_vm._v("Monthly cost:")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "bg-grey-light p-4 text-center my-4 rounded border border-grey"
  }, [_vm._v(_vm._s(_vm.formatCost(_vm.totalCost)))])])])])]), _vm._v(" "), _vm._m(1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-grey-darkest"
  }, [_c('th', {}, [_vm._v("API Calls")]), _vm._v(" "), _c('th', {}, [_vm._v("Price Per Call")]), _vm._v(" "), _c('th', {}, [_vm._v("Total Price")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-sm"
  }, [_vm._v("\n      Card payments securely processed by "), _c('a', {
    staticClass: "no-underline",
    attrs: {
      "target": "_blank",
      "href": "https://www.stripe.com"
    }
  }, [_vm._v("Stripe")]), _vm._v(".\n    ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cb79768","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/home/pricing-calculator.vue
// module id = 674
// module chunks = 0